import styled from 'styled-components';

export const Container = styled.section`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
  margin-bottom: 28px;

  @media ${({ theme }) => theme.devices.mobile} {
    margin-bottom: 20px;
    gap: 8px;
  }

  button {
    width: 100%;
    color: ${({ theme }) => theme.colors.grey.white};

    h4 {
      @media ${({ theme }) => theme.devices.mobile} {
        font-size: 16px;
      }
    }
  }
`;

export const Top = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;

  @media ${({ theme }) => theme.devices.mobile} {
    gap: 4px;
    flex-direction: column;
  }

  h2 {
    @media ${({ theme }) => theme.devices.mobile} {
      font-size: 24px;
    }

    b {
      font-weight: 700;
      color: ${({ theme }) => theme.colors.primary.main};
    }
  }

  div {
    display: flex;
    align-items: center;
    gap: 8px;

    p {
      span {
        margin-right: 4px;
        font-size: 20px;

        @media ${({ theme }) => theme.devices.mobile} {
          font-weight: 700;
          font-size: 16px;
        }
      }
    }
  }
`;
